import script from "./Segmented.vue?vue&type=script&lang=ts&setup=true"
export * from "./Segmented.vue?vue&type=script&lang=ts&setup=true"

import "./Segmented.vue?vue&type=style&index=0&id=2a9ab163&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a9ab163"]])

export default __exports__